import {AustraliaDifficultyLevel} from "./types";

import {GAME_AUSTRALIA} from "../../../Games";
import {Game} from "../../../types";
import {StringUtil} from "../../../../shared/string_util";
import {$KTS} from "../../../../shared/types";
import {MapGameFragment} from "../MapGameFragment";
import {ReactComponent as AustraliaMap} from "../res/australia.svg";
import {Component} from "react";
import {Country, AUSTRALIA_COUNTRIES} from "../types";

export class AustraliaGameFragment extends MapGameFragment<AustraliaDifficultyLevel> {

  protected getGame(): Game {
    return GAME_AUSTRALIA;
  }

  protected allCountries(): Country[] {
    return AUSTRALIA_COUNTRIES;
  }

  protected getMapComponent(): typeof Component {
    //@ts-ignore
    return AustraliaMap;
  }

  protected getLevels(): AustraliaDifficultyLevel[] {
    return AustraliaDifficultyLevel.VALUES;
  }

  protected getResultText(): string {
    let resultText: string = "You completed %{level} game.";
    switch (this.state.gameConfig.level) {
      case AustraliaDifficultyLevel.MEDIUM:
        resultText = StringUtil.format(resultText, $KTS("level", "a medium"));
        break;
    }
    return resultText;
  }
}